import { ShadcnTextField } from './ShadcnTextField';
import { ShadcnTextArea } from './ShadcnTextArea';
import { ShadcnSelect } from './ShadcnSelect';
import { ShadcnSwitch } from './ShadcnSwitch';
import { ShadcnDivider } from './ShadcnDivider';
import { ShadcnDateTimeField } from './ShadcnDateTimeField';
import { ShadcnDateField } from './ShadcnDateField';
import { ShadcnMarkdown } from './ShadcnMarkdown';
import { ShadcnImage } from './ShadcnImage';
const shadcnRenderers = {
    string: ShadcnTextField,
    textarea: ShadcnTextArea,
    number: ShadcnTextField,
    boolean: ShadcnSwitch,
    select: ShadcnSelect,
    select_multi: ShadcnSelect,
    date: ShadcnDateTimeField,
    day: ShadcnDateField,
    spacetime: ShadcnTextField, // fallback to text input
    markdown: ShadcnMarkdown,
    divider: ShadcnDivider,
    image: ShadcnImage
};
export { shadcnRenderers };
export { ShadcnTextField } from './ShadcnTextField';
export { ShadcnTextArea } from './ShadcnTextArea';
export { ShadcnSelect } from './ShadcnSelect';
export { ShadcnSwitch } from './ShadcnSwitch';
export { ShadcnDivider } from './ShadcnDivider';
export { ShadcnDateField } from './ShadcnDateField';
export { ShadcnDateTimeField } from './ShadcnDateTimeField';
export { ShadcnMarkdown } from './ShadcnMarkdown';
export { ShadcnImage } from './ShadcnImage';
//# sourceMappingURL=index.js.map